import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { MediaQueryService } from '@frontend/vanilla/core';
import { distinctUntilChanged, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DeviceSizeService {
    private readonly mediaQueryService = inject(MediaQueryService);

    private readonly mobileMediaQuery$ = this.mediaQueryService.observe().pipe(
        map(() => this.mediaQueryService.isActive('lt-md')),
        distinctUntilChanged(),
    );

    readonly isMobile = toSignal(this.mobileMediaQuery$, { requireSync: true });
}
